<template>
  <div
    v-if="bannerState !== BannerState.HIDDEN"
    class="w-full py-3 py relative"
  >
    <div
      class="h-full w-fit px-5 bg-primary flex items-center justify-center rounded-l-xl z-10 absolute left-0 top-0"
    >
      <Icon :icon="InfoSvg" class="text-on-primary" />
    </div>
    <div
      class="relative z-20 pl-20 pr-10 h-full w-full flex gap-4 md:gap-2 items-center flex-wrap justify-center md:justify-between"
    >
      <span class="md:text-left">
        {{ $t(`onboarding.onboarding-banner.${bannerState}.message`) }}
      </span>
      <Btn
        v-if="bannerState === BannerState.ACTIVE"
        to="/onboarding"
        :color="BtnColor.PRIMARY"
        :variant="BtnVariant.FILLED"
      >
        {{ $t('onboarding.onboarding-banner.active.button-text') }}
      </Btn>

      <Btn
        v-else
        :color="BtnColor.PRIMARY"
        :variant="BtnVariant.FILLED"
        @click="onDismissClick"
      >
        {{ $t('onboarding.onboarding-banner.expired.button-text') }}
      </Btn>
    </div>

    <div
      class="bg-primary opacity-10 w-full h-full absolute left-0 top-0 rounded-xl z-10"
    />
    <div class="bg-[white] w-full h-full absolute left-0 top-0 rounded-xl" />
  </div>
</template>

<script setup lang="ts">
import { Icon } from '~/components/icon';
import { Btn, BtnColor, BtnVariant } from '~/components/btn';
import InfoSvg from '~/assets/icons/info.svg?component';
import { useAccountStore } from '~/store/account';
import { BusinessResponseDto } from '~/api/businesses';
import { useLoader } from '~/composables/use-loader';
import { apiDismissOnboardingBannerOnboarding } from '~/api/onboarding';

const props = defineProps<{
  business: BusinessResponseDto;
}>();

const { refreshCurrentAccount } = useAccountStore();

enum BannerState {
  HIDDEN = 'hidden',
  ACTIVE = 'active',
  EXPIRED = 'expired',
}

const bannerState = computed<BannerState>(() => {
  const isAssigned = props.business.businessOnboarding !== null;
  const isDismissed = props.business.onboardingBannerDismissedAt !== null;

  if (!isAssigned || isDismissed || props.business.isOnboardingCompleted) {
    return BannerState.HIDDEN;
  }

  return props.business.isOnboardingExpired
    ? BannerState.EXPIRED
    : BannerState.ACTIVE;
});

const onDismissClick = async () => {
  await useLoader({
    async action() {
      await apiDismissOnboardingBannerOnboarding();
      await refreshCurrentAccount();
    },
  });
};
</script>
